import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, CopyButton, Tooltip } from '@node-space/ui-components'
import { Card } from 'services/CardService'
import { CustomerWallet } from 'types/customers'
import { CardArt } from './CardArt'
import { CardStatusHighlight } from './CardStatusHighlight'
import { formatWalletBalance } from './utils/cardUtils'

interface CardDetailsSidePanelHeaderProps {
  card: Card
  wallet: CustomerWallet
}

export const CardDetailsSidePanelHeader = ({ card, wallet }: CardDetailsSidePanelHeaderProps) => {
  const { t } = useTranslation()

  return (
    <Box flex align="start" gap={16} width="full">
      <Box className="shrink-0">
        <CardArt />
      </Box>

      <Box flexCol gap={4} className="min-w-0 flex-1">
        <Box tag="h2" className="text-h2 text-foreground-prominent">
          {formatWalletBalance(wallet.balance)} {t('balance').toLowerCase()}
        </Box>

        <Box flex align="center" gap={4}>
          <p className="text-body-regular text-foreground-prominent break-all">{card.id}</p>
          <Tooltip
            type="simple"
            bodyContent={t('customers.cardDetails.copyCardId')}
            position="bottom"
            triggerAsChild={false}
          >
            <CopyButton copyText={card.id} testId="card-details-copy-id" noPadding />
          </Tooltip>
        </Box>

        <Box paddingT={4}>
          <CardStatusHighlight status={card.status} />
        </Box>
      </Box>
    </Box>
  )
}
